const p = ":host{display:block}.sl-step-indicator{display:flex;align-items:center;justify-content:center}.sl-step-indicator--vertical{flex-direction:column;align-items:flex-start}.sl-step-indicator__item{display:flex;align-items:flex-start}.sl-step-indicator--vertical .sl-step-indicator__item{flex-direction:column;align-items:flex-start}.sl-step-indicator__circle{display:flex;align-items:center;justify-content:center;width:2.25rem;height:2.25rem;border-radius:var(--sl-radius-full);font-family:var(--sl-font-family-base);font-size:var(--sl-font-size-sm);font-weight:var(--sl-font-weight-medium);cursor:pointer;transition:background-color var(--sl-transition-fast),color var(--sl-transition-fast);flex-shrink:0;user-select:none}.sl-step-indicator__circle--current{background-color:hsl(var(--sl-hsl-primary));color:hsl(var(--sl-hsl-primary-foreground))}.sl-step-indicator__circle--completed{background-color:hsl(var(--sl-hsl-primary) / 0.2);color:hsl(var(--sl-hsl-primary));border:1.5px solid hsl(var(--sl-hsl-primary))}.sl-step-indicator__circle--pending{background-color:hsl(var(--sl-hsl-muted));color:hsl(var(--sl-hsl-muted-foreground))}.sl-step-indicator__icon{width:1rem;height:1rem}.sl-step-indicator__label{font-family:var(--sl-font-family-base);font-size:var(--sl-font-size-xs);font-weight:var(--sl-font-weight-medium);color:hsl(var(--sl-hsl-foreground));margin-top:var(--sl-spacing-1);text-align:center}.sl-step-indicator--vertical .sl-step-indicator__label{margin-top:0;margin-left:var(--sl-spacing-3);text-align:left;align-self:center}.sl-step-indicator__item-inner{display:flex;flex-direction:column;align-items:center}.sl-step-indicator--vertical .sl-step-indicator__item-inner{flex-direction:row}.sl-step-indicator__connector{flex:1;height:2px;min-width:2rem;background-color:hsl(var(--sl-hsl-muted));margin:calc(1.125rem - 1px) var(--sl-spacing-2) 0;transition:background-color var(--sl-transition-fast)}.sl-step-indicator__connector--completed{background-color:hsl(var(--sl-hsl-primary))}.sl-step-indicator--vertical .sl-step-indicator__connector{width:2px;height:2rem;min-width:unset;margin:var(--sl-spacing-1) 0 var(--sl-spacing-1) 1.0625rem;flex:unset}", h = '<svg class="sl-step-indicator__icon" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>';
class _ extends HTMLElement {
  constructor() {
    super(), this._stepClickHandlers = /* @__PURE__ */ new Map(), this._stepKeydownHandlers = /* @__PURE__ */ new Map(), this._shadow = this.attachShadow({ mode: "open" }), this._render();
  }
  static get observedAttributes() {
    return ["steps", "current", "variant"];
  }
  connectedCallback() {
    this._addStepListeners();
  }
  disconnectedCallback() {
    this._removeStepListeners();
  }
  attributeChangedCallback(t, e, i) {
    e !== i && (this._removeStepListeners(), this._render(), this.isConnected && this._addStepListeners());
  }
  get steps() {
    const t = this.getAttribute("steps");
    if (!t) return [];
    try {
      const e = JSON.parse(t);
      return Array.isArray(e) ? e : [];
    } catch {
      return console.warn("[sl-step-indicator] Invalid JSON in steps attribute"), [];
    }
  }
  set steps(t) {
    this.setAttribute("steps", JSON.stringify(t));
  }
  get current() {
    return parseInt(this.getAttribute("current") || "0", 10);
  }
  set current(t) {
    this.setAttribute("current", String(t));
  }
  get variant() {
    return this.getAttribute("variant") || "horizontal";
  }
  set variant(t) {
    this.setAttribute("variant", t);
  }
  _renderStep(t, e, i) {
    const r = this.current, n = e === r, s = e < r, a = e > r;
    let l = "sl-step-indicator__circle";
    n ? l += " sl-step-indicator__circle--current" : s ? l += " sl-step-indicator__circle--completed" : a && (l += " sl-step-indicator__circle--pending");
    const o = s ? h : `<span>${e + 1}</span>`, c = [
      "sl-step-indicator__connector",
      s ? "sl-step-indicator__connector--completed" : ""
    ].filter(Boolean).join(" "), d = i ? "" : `<div class="${c}"></div>`;
    return `
      <div class="sl-step-indicator__item">
        <div class="sl-step-indicator__item-inner">
          <div
            class="${l}"
            data-index="${e}"
            role="button"
            tabindex="0"
            aria-label="Step ${e + 1}: ${t.label}"
            aria-current="${n ? "step" : "false"}"
          >${o}</div>
          <div class="sl-step-indicator__label">${t.label}</div>
        </div>
        ${d}
      </div>
    `;
  }
  _render() {
    const t = this.steps, i = [
      "sl-step-indicator",
      `sl-step-indicator--${this.variant}`
    ].join(" "), r = t.map((n, s) => this._renderStep(n, s, s === t.length - 1)).join("");
    this._shadow.innerHTML = `
      <style>${p}</style>
      <div class="${i}" role="list">
        ${r}
      </div>
    `;
  }
  _addStepListeners() {
    this._shadow.querySelectorAll("[data-index]").forEach((t) => {
      const e = parseInt(t.dataset.index || "0", 10), i = () => this._onStepClick(e), r = (n) => {
        const s = n;
        (s.key === "Enter" || s.key === " ") && (s.preventDefault(), this._onStepClick(e));
      };
      t.addEventListener("click", i), t.addEventListener("keydown", r), this._stepClickHandlers.set(t, i), this._stepKeydownHandlers.set(t, r);
    });
  }
  _removeStepListeners() {
    this._stepClickHandlers.forEach((t, e) => {
      e.removeEventListener("click", t);
    }), this._stepKeydownHandlers.forEach((t, e) => {
      e.removeEventListener("keydown", t);
    }), this._stepClickHandlers.clear(), this._stepKeydownHandlers.clear();
  }
  _onStepClick(t) {
    this.dispatchEvent(new CustomEvent("step-click", {
      bubbles: !0,
      composed: !0,
      detail: { index: t }
    }));
  }
}
typeof customElements < "u" && !customElements.get("sl-step-indicator") && customElements.define("sl-step-indicator", _);
export {
  _ as SlStepIndicatorElement
};
//# sourceMappingURL=sl-step-indicator.js.map
